import Dialog from "@mui/material/Dialog";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import React from "react";
import useStore from "store/hook";
import { toast } from "react-toastify";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import Activateuser from "assets/images/users/activateuser.png";
import Deactivateuser from "assets/images/users/deactivateuser.png";
import { useChangeuserstatusMutation } from "store/api/users.api";

const ActivateDeactivateUser = () => {
  const { store, setDialogue } = useStore();
  const logout = useLogout();

  const {
    app: {
      dialogs: {
        activateDeactivateUser: { isOpen, action, userId },
      },
    },
  } = store;

  const handleClose = () => {
    setDialogue({
      type: "activateDeactivateUser",
      isOpen: false,
      action: "",
      userId: "",
    });
  };

  const [changeuserstatus, { isLoading, error }] = useChangeuserstatusMutation();

  const changeStatus = async () => {
    try {
      const response = await changeuserstatus({ user_id: userId }).unwrap();

      if (response?.status == 1) {
        toast.success(Formatmessage(response?.message) || "School status updated successfully");
        handleClose();
      } else if (response?.status == 0) {
        toast.error(Formatmessage(response?.message));
      } else if (response?.status == 10) {
        logout();
      }
    } catch (error) {
      console.log("eror", error);
      toast.error("Server error. please try again in a few minutes.");
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "25px",
            m: {
              xs: 1,
              sm: 1,
              md: 2,
            },
          },
        }}
      >
        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>

        <SoftBox
          width="100%"
          display="flex"
          flexDirection="column"
          sx={{
            overflowY: "scroll",
            backgroundColor: "white.main",
            "&::-webkit-scrollbar": { display: "none" },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          <SoftBox
            display="flex"
            width="100%"
            flexDirection="column"
            gap={2}
            sx={{ p: { xs: 1, sm: 2, md: 2 } }}
          >
            <SoftBox display="flex" alignItems="center" justifyContent="center">
              <SoftBox
                height="140px"
                width="140px"
                borderRadius="lg"
                sx={{
                  backgroundImage: `url(${action == "activate" ? Activateuser : Deactivateuser})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              />
            </SoftBox>

            <SoftBox display="flex" alignItems="center" justifyContent="center">
              <SoftTypography sx={{ fontSize: 18 }} color="black" fontWeight="medium">
                {action == "activate" ? "Activate User Account" : "Deactivate User Account"}
              </SoftTypography>
            </SoftBox>

            <SoftBox display="flex" alignItems="center" justifyContent="center">
              <SoftTypography
                sx={{ fontSize: 16 }}
                align="center"
                color="lightblack"
                fontWeight="medium"
              >
                {action == "activate"
                  ? "Do you want to activate this users account? Once activated, the user will regain full access to the platform."
                  : "Are you sure you want to deactivate this user’s account? The user will no longer have access until reactivated."}
              </SoftTypography>
            </SoftBox>

            <SoftBox
              width="100%"
              display="flex"
              gap={2}
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <SoftButton
                onClick={handleClose}
                color="dark"
                sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
                variant="outlined"
              >
                Cancel
              </SoftButton>

              <SoftButton
                disabled={isLoading}
                onClick={changeStatus}
                color="primary"
                sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
                variant="contained"
              >
                {isLoading
                  ? "...Loading"
                  : `Yes, ${action === "activate" ? "Activate" : "Deactivate"}`}
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </SoftBox>

        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main", mt: "auto" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>
      </Dialog>
    </React.Fragment>
  );
};

export default ActivateDeactivateUser;
